$(document).ready(function () {
    // возвращает куки с указанным name,
    // или undefined, если ничего не найдено
    function getCookie(name) {
        let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    function initDarkTheme(){
        $('.page').removeClass('white-theme');
        $('.page').addClass('page--dark');
        $('.b-preorder__clicker').removeClass('stand');
        $('.b-preorder__clicker').addClass('claim');
    }

    function initWhiteTheme(){
        $('.page').addClass('white-theme');
        $('.page').removeClass('page--dark');
        $('.b-preorder__clicker').removeClass('claim');
        $('.b-preorder__clicker').addClass('stand');
    }

    $(document).on('click', '.js-preorder-stand', function () {
        document.cookie = "theme=white";
        initWhiteTheme();
    });

    $(document).on('click', '.js-preorder-claim', function () {
        document.cookie = "theme=dark";
        initDarkTheme();
    });

    if ($('.page').hasClass('page--main')){
        if(getCookie("theme") == "dark"){
            initDarkTheme();
        }else if(getCookie("theme") == "white"){
            initWhiteTheme();
        }
    }
});


// WEBPACK FOOTER //
// ./src/js/pages/main/preorder.js